module.exports = "<div class=form-grid__row> <div class=\"form-grid__col form-grid__col8\"> <label class=md-body-1>Labels</label> </div> <dt-labels-autocomplete flex labels=$ctrl.labels require-match=true editable=true on-change=$ctrl.changed($event)></dt-labels-autocomplete> <div class=\"form-grid__col form-grid__col12\"> <dt-help-icon message-key=help_icon_advanced_search_labels></dt-help-icon> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/search/advanced/thing-labels/thing-labels.html
// module id = 70dX
// module chunks = 1